// extracted by mini-css-extract-plugin
export var darkMode = "_27-0";